import React, { FC, useState } from 'react';
import {
  CatSkeleton,
  CatTableCell,
  CatTableRow,
  CatTextLink
} from 'components/blocks-components';
import {
  getPartsDetails,
  partWhereUsedApiCall
} from 'services/parts-diagram/actions';
import useURLParams from 'hooks/useURLParams';
import styles from './multiple-system-link.module.scss';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';
import { CATEGORY_TYPES } from 'types/parts-diagram';

export interface MultipleSystemLinkProps {
  partNumber: string;
  name: string;
}

const MultipleSystemLink: FC<MultipleSystemLinkProps> = ({
  partNumber,
  name
}) => {
  const [groupPartData, setGroupPartData] = useState(null);
  const [loading, setLoading] = useState(false);

  const { handlePartsContentCategory, handleSelectedPart } = usePartDiagram();
  const { setParamsWithWindows } = useURLParams();

  const handleClick = async (partNumber) => {
    setLoading(true);
    const partWhereUsedResponse = await partWhereUsedApiCall(partNumber);
    setGroupPartData(partWhereUsedResponse);
    setLoading(false);
  };

  const handlePartsDetails = async (
    componentId,
    systemId,
    ieSystemControlNumber
  ) => {
    handlePartsContentCategory(CATEGORY_TYPES.LOADER);
    setParamsWithWindows('systemId', systemId);
    setParamsWithWindows('componentId', componentId);
    setParamsWithWindows('ieSystemControlNumber', ieSystemControlNumber);

    const { partDetailsAndSchematicResponse } = await getPartsDetails(
      ieSystemControlNumber
    );

    if (partDetailsAndSchematicResponse) {
      handlePartsContentCategory(
        CATEGORY_TYPES.PARTSDETAILS,
        null,
        partDetailsAndSchematicResponse
      );
      handleSelectedPart({ partNumber, ieSystemControlNumber });
    }
  };

  return (
    <>
      <CatTableRow isExpandable>
        <CatTableCell onClick={(e) => handleClick(partNumber)}>
          {`${partNumber} : ${name}`}
        </CatTableCell>
      </CatTableRow>

      <CatTableRow isExpandableChild>
        <CatTableCell className={styles['table_padding_remove']}>
          {loading && !groupPartData && (
            <CatTableRow>
              <CatSkeleton />
            </CatTableRow>
          )}
          {groupPartData?.map((system) => (
            <>
              <CatTableRow>
                <CatTableCell className={styles['table_subHeading_background']}>
                  {system.systemName}
                </CatTableCell>
              </CatTableRow>
              {system.components.map((component) => (
                <CatTableRow key={component.componentId}>
                  <CatTableCell className={styles['table_subHeading_padding']}>
                    <CatTextLink
                      size="sm"
                      onClick={(e) =>
                        handlePartsDetails(
                          component.componentId,
                          system.systemId,
                          system.ieSystemControlNumber
                        )
                      }
                    >
                      {`${component.componentId} : ${component.componentName}`}
                    </CatTextLink>
                  </CatTableCell>
                </CatTableRow>
              ))}
            </>
          ))}
        </CatTableCell>
      </CatTableRow>
    </>
  );
};

export default MultipleSystemLink;
